import React from 'react';

/*
initialize launch darkly flags. Any flag being used must be
included here. Set the attribute name to the camelCase version
of the launch darkly flag.
*/
export const launch_darkly_flags = {
  reserve: true,
  // miEdgeAllowStatistics: false, // example of launch darkly flag
  isFetching: true, // indicates whether the launch darkly flags are currently being loaded
  ldMiedgeBrokerSearchPremiumAllocationSummary: false,
  ldMiedgeBrokerSearchFilterContactRoleTitles: false,
  ldMiedgeBrokerSearchBrokerShare: false,
  ldMiedgeBrokerSearchForAll: false,
};

export const FlagsContext = React.createContext(launch_darkly_flags);
